import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { StyledPaperContainer } from '../../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import { StyledButtonsContainer } from '../../../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import DeleteClinicMasterProduct from '../Buttons/DeleteClinicMasterProduct';
import { ClinicProduct } from '../../../../apis/clinic-products/types';
import SaveClinicMasterProduct from '../Buttons/SaveClinicMasterProduct';
import { ClinicMasterProduct } from '../../../../apis/clinic-master-products/types';

interface ClinicMasterProductFooterProps {
  id: string;
  clinicId: string;
  productsForm: UseFormReturn<ClinicProduct[]>;
  form: UseFormReturn<ClinicMasterProduct>;
}

export const ModifyClinicMasterProductFooter = ({
  clinicId,
  productsForm,
  form,
  id
}: ClinicMasterProductFooterProps) => {
  return (
    <StyledPaperContainer>
      <StyledButtonsContainer>
        <DeleteClinicMasterProduct clinicId={clinicId} id={id} />
        <SaveClinicMasterProduct form={form} productsForm={productsForm} id={id} />
      </StyledButtonsContainer>
    </StyledPaperContainer>
  );
};
